<template>
  <div>
    <Modal
      title="付款"
      :value="visiblePayMsg"
      width="80%"
      :mask-closable="false"
      @on-cancel="() => changeVisiblePayMsg(false)"
    >
      <div style="text-align: left; font-size: 20px; color: red">
        <p>
          学员报名缴费成功后，原则上不予退课退费。具体规定详见招生简章。请您谨慎选择您要报名的课程。
          <template v-if="prohibitPayment.canPay === '0'">
            <br />{{ prohibitPayment.reason }}
          </template>
        </p>
      </div>
      <!-- PC端表格视图 -->
      <Table
        v-if="!isMobile"
        @on-selection-change="changhePay"
        ref="selectionPay"
        :columns="payColumns"
        :data="payData"
        class="tableContent"
        stripe
      >
      </Table>
      <!-- 移动端卡片视图 -->
      <div v-else class="mobile-cards">
        <div
          v-for="(item, index) in payData"
          :key="index"
          class="course-card"
          :class="{ selected: selectedCourses.includes(item.orderNo) }"
          @click="toggleCourseSelection(item)"
        >
          <div class="card-header">
            <Checkbox
              :value="selectedCourses.includes(item.orderNo)"
              @on-change="(checked) => handleCheckboxChange(checked, item)"
            ></Checkbox>
            <span class="course-name">{{ item.course }}</span>
          </div>
          <div class="card-content">
            <div class="info-row">
              <span class="label">任课老师:</span>
              <span class="value">{{ item.teacher }}</span>
            </div>
            <div class="info-row">
              <span class="label">开课时间:</span>
              <span class="value">{{ item.beginDt || item.classBegin }}</span>
            </div>
            <div class="info-row">
              <span class="label">上课时间:</span>
              <span class="value">{{ item.classBegin }}</span>
            </div>
            <div class="info-row">
              <span class="label">上课地点:</span>
              <span class="value">{{ item.address }}</span>
            </div>
            <div class="info-row">
              <span class="label">学费:</span>
              <span class="value price">¥{{ item.amount }}</span>
            </div>
            <div v-if="type === 'myLeasson'" class="info-row">
              <span class="label">订单状态:</span>
              <span class="value status">{{ getOrderStatus(item.orderStatus) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <span :style="{ float: isMobile ? 'right' : 'left' }"
          >总计<span style="color: red">{{ totAmount }}</span
          >元</span
        >
        <Button @click="allCourses" v-if="!isMobile">选择其他课程</Button>
        <Button
          type="primary"
          :disabled="
            (type === 'applyFlow' && isdisabledFn) ||
            prohibitPayment.canPay === '0'
          "
          @click="payInvoice"
        >
          立即缴费</Button
        >
      </div>
    </Modal>
    <Modal
      title="开票信息"
      v-model="visibleInvoiceMsg"
      width="80%"
      :mask-closable="false"
      :loading="loading"
    >
      <my-Invoice v-if="visibleInvoiceMsg" ref="invoiceForm"></my-Invoice>
      <!-- 底部按钮 -->
      <template #footer>
        <Button type="primary" @click="payBill">确定</Button>
        <Button @click="visibleInvoiceMsg = false" v-if="!isMobile">取消</Button>
      </template>
    </Modal>
    <!-- 财务处跳转遮罩 -->
    <div v-if="showMask" class="mask">
      <div class="loading-message">正在跳转财务处...</div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import myInvoice from "@/views/myAccount/myInvoice.vue";

export default {
  components: { myInvoice },
  data() {
    return {
      loading: true,
      billno: "",
      isdisabledFn: true,
      visibleInvoiceMsg: false,
      prohibitPayment: {
        canPay: "1",
        reason: "",
      },
      totAmount: 0,
      totAmountStrList: "",
      selectedCourses: [], // 新增：用于存储选中的课程
      isMobile: false, // 新增：用于判断是否为移动端
      isWechat: false, // 新增：用于判断是否为微信环境
      payColumns:
        this.type === "myLeasson"
          ? [
              {
                title: "课程名称",
                key: "course",
                width: 200,
              },
              {
                title: "任课老师",
                key: "teacher",
                width: 150,
              },
              {
                title: "开课时间",
                width: 150,
                key: "beginDt",
              },
              {
                title: "上课时间",
                width: 200,
                key: "classBegin",
              },
              {
                title: "上课地点",
                width: 390,
                key: "address",
              },
              {
                title: "学费",
                width: 100,
                key: "amount",
              },
              {
                title: "订单状态",
                width: 150,
                key: "orderStatus",
                render: (h, params) => {
                  const text = this.getOrderStatus(params.row.orderStatus);
                  return h("span", text);
                },
              },
            ]
          : [
              {
                type: "selection",
                title: "订单编号",
                key: "orderNo",
                disabled: true,
              },
              {
                title: "课程名",
                key: "course",
              },
              {
                title: "任课老师",
                key: "teacher",
              },
              {
                title: "上课时间",
                key: "classBegin",
              },
              {
                title: "上课地址",
                key: "address",
              },
              {
                title: "学期",
                key: "year",
                render: (h, params) => {
                  const text =
                    params.row.xq === "1"
                      ? "春季"
                      : params.row.xq === "2"
                      ? "秋季"
                      : "";
                  const textHtml = params.row.year + text;
                  return h("span", textHtml);
                },
              },
              {
                title: "学费",
                key: "amount",
              },
            ],
      showMask: false,
    };
  },
  props: {
    type: String,
    visiblePayMsg: Boolean,
    payData: Array,
  },
  watch: {
    visiblePayMsg(value) {
      console.log("[visiblePayMsg]value:", value, "this.type", this.type);
      if (value&this.type === "myLeasson") {
        if (!this.isMobile) {
          this.changhePay(this.payData);
        } else {
          // 在移动端自动选中所有课程
          this.selectedCourses = this.payData.map(item => item.orderNo);
          this.updatePayment();
        }
      }
    },
  },
  methods: {
    changhePay(selection) {
      if (this.isMobile) return; // 移动端使用新的选择逻辑
      this.totAmount = 0;
      this.isdisabledFn = true;
      let billnoList = [];
      let amountList = [];
      selection.forEach((item) => {
        billnoList.push(item.orderNo);
        amountList.push(item.amount);
        this.totAmount = (
          parseFloat(this.totAmount) + parseFloat(item.amount)
        ).toFixed(2);
      });

      if (billnoList.length > 0) {
        this.isdisabledFn = false;
      }
      this.billno = billnoList.join(",");
      this.totAmountStrList = amountList.join(",");
    },
    changeVisiblePayMsg(value) {
      this.$emit("changeVisiblePayMsg", value);
    },
    payInvoice() {
      this.visibleInvoiceMsg = true;
    },
    allCourses() {
      this.changeVisiblePayMsg(false);
      //this.$router.push({ path: "/" });
    },
    payBill() {
      console.log("this.payBill");
      var _this = this;
      _this.$refs.invoiceForm.$refs.formInvoice.validate((valid) => {
        console.log("isvalid", valid);
        if (valid) {
          // 获取表单数据，验证纳税人识别号格式
          var invoiceData = _this.$refs.invoiceForm.formInvoice;
          
          // 如果是单位发票，验证纳税人识别号格式
          if (invoiceData.changeRadio == "2") {
            if (!invoiceData.dutyNo) {
              _this.$Message.error('纳税人识别号不能为空');
              _this.loading = false;
              return;
            }
            
            // 统一社会信用代码（18位）正则
            const creditCodeReg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
            // 旧税号（15位）正则
            const oldTaxNoReg = /^\d{15}$/;
            
            if (!creditCodeReg.test(invoiceData.dutyNo) && !oldTaxNoReg.test(invoiceData.dutyNo)) {
              _this.$Message.error('请输入正确的纳税人识别号');
              _this.loading = false;
              return;
            }
          }
          
          let invoiceParams = this.$refs.invoiceForm.getInvoiceParam();
          let receiveConfig = this.$refs.invoiceForm.getReceiveConfig();
          console.log(
            "invoice params:",
            invoiceParams,
            "receiveConfig:",
            receiveConfig,
            "billno:",
            _this.billno
          );

          if (_this.billno) {
            this.showMask = true;

            _this.$http
              .post(
                "retire-school-manage/course/appPay",
                qs.stringify({
                  payEnv: _this.isWechat ? 'wx' : (_this.isMobile ? 'h5' : 'pc'), // 判断支付环境
                  billno: _this.billno, // 订单号
                  orderinfono: sessionStorage.getItem("studentId").substr(0, 10), // 缴费用户编号
                  orderinfoname: sessionStorage.getItem("userNameSchool"), // 缴费用户姓名
                  amt: _this.totAmountStrList, // 费用
                  returnURL:
                    process.env.NODE_ENV === "production"
                      ? "http://tjltb.tongji.edu.cn/retireSchool"
                      : "http://192.168.165.100/retireSchool",
                  ...invoiceParams,
                  ...receiveConfig,
                })
              )
              .then((res) => {
                if (res.status === 200) {
                  this.changeVisiblePayMsg(true);
                  window.location.href = res.data;
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            _this.$CustomMessageError("付款失败，请选择付款的课程!");
          }
        } else {
          _this.loading = false;
        }
      });
    },
    // 新增方法：获取订单状态文本
    getOrderStatus(status) {
      const statusMap = {
        "0": "待审核",
        "1": "待缴费",
        "2": "已缴费",
        "3": "已退款",
        "4": "已逾期",
        "5": "退课中",
        "6": "已退课",
        "7": "已取消"
      };
      return statusMap[status] || "";
    },
    // 新增方法：切换课程选择
    toggleCourseSelection(item) {
      const index = this.selectedCourses.indexOf(item.orderNo);
      if (index === -1) {
        this.selectedCourses.push(item.orderNo);
      } else {
        this.selectedCourses.splice(index, 1);
      }
      this.updatePayment();
    },
    // 新增方法：处理复选框变化
    handleCheckboxChange(checked, item) {
      if (checked) {
        this.selectedCourses.push(item.orderNo);
      } else {
        const index = this.selectedCourses.indexOf(item.orderNo);
        if (index > -1) {
          this.selectedCourses.splice(index, 1);
        }
      }
      this.updatePayment();
    },
    // 新增方法：更新支付金额
    updatePayment() {
      this.totAmount = 0;
      let billnoList = [];
      let amountList = [];
      
      this.payData.forEach((item) => {
        if (this.selectedCourses.includes(item.orderNo)) {
          billnoList.push(item.orderNo);
          amountList.push(item.amount);
          this.totAmount = (
            parseFloat(this.totAmount) + parseFloat(item.amount)
          ).toFixed(2);
        }
      });

      this.isdisabledFn = billnoList.length === 0;
      this.billno = billnoList.join(",");
      this.totAmountStrList = amountList.join(",");
    },
    // 新增：判断是否为微信环境
    checkIsWechat() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('micromessenger') !== -1;
    },
  },
  created() {
    // 检测是否为移动端
    this.isMobile = window.innerWidth <= 768;
    // 检测是否为微信环境
    this.isWechat = this.checkIsWechat();
    // 监听窗口大小变化
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 768;
    });

    this.$http
      .get("/retire-school-manage/config/prohibitPayment")
      .then((res) => {
        this.prohibitPayment = res.data.data;
      });
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 768;
    });
  },
};
</script>
<style scoped>
/* 移动端卡片样式 */
.mobile-cards {
  padding: 8px;
}

.course-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #eee;
  transition: all 0.3s ease;
}

.course-card.selected {
  border-color: #2d8cf0;
  background-color: #f8f9fe;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 12px;
}

.course-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  flex: 1;
}

.card-content {
  padding-left: 28px;
}

.info-row {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.5;
}

.info-row .label {
  color: #666;
  min-width: 70px;
  margin-right: 8px;
}

.info-row .value {
  color: #333;
  flex: 1;
}

.info-row .price {
  color: #f56c6c;
  font-weight: 500;
}

.info-row .status {
  color: #409eff;
}

/* 移动端适配样式 */
@media screen and (max-width: 768px) {
  .ivu-modal {
    top: 0 !important;
    width: 100% !important;
    margin: 0 !important;
  }

  .ivu-modal-content {
    border-radius: 0;
  }

  .ivu-modal-header {
    padding: 12px 16px;
  }

  .ivu-modal-body {
    padding: 12px;
    max-height: calc(100vh - 108px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ivu-modal-footer {
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .ivu-modal-footer::after {
    content: '';
    display: table;
    clear: both;
  }

  .ivu-modal-footer button {
    margin: 0 !important;
    width: 100%;
    height: 40px;
    font-size: 20px;
    padding: 0;
  }

  /* 移动端警告文本 */
  div[style*="text-align: left; font-size: 20px; color: red"] {
    font-size: 14px !important;
    padding: 8px;
    line-height: 1.5;
  }

  /* 移动端底部总计样式 */
  .ivu-modal-footer span[style*="float: left"] {
    float: right !important;
    margin-bottom: 12px;
    font-size: 16px;
    width: 100%;
    text-align: right;
  }
}

/* 遮罩层样式 */
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-message {
  color: white;
  font-size: 16px;
  padding: 16px 24px;
  background: rgba(0, 0, 0, 0.75);
  border-radius: 4px;
}
</style>
